{
  "apiKey": "AIzaSyBW4nye5kPuPFaMvUEzJ9AU_cGI1R7S3Jw",
  "authDomain": "broox-studio-analytics.firebaseapp.com",
  "projectId": "broox-studio-analytics",
  "storageBucket": "broox-studio-analytics.firebasestorage.app",
  "messagingSenderId": "959229389937",
  "appId": "1:959229389937:web:595b87172f95514037ffd0"
}